import { KEY_VALUE_LAYOUT, KeyConfig } from 'commons-ui';

import { IRefundSuggestionProps } from '../types';
import { VIEW_FIELD_KEYS } from './constants';
import useService from './useService';

export const getKeyConfig = (props: IRefundSuggestionProps) => {
	const { getRefundSuggestionDetails, refundSuggestionDetails } = useService(props);

	const keyConfig: KeyConfig = {
		childConfig: [
			{
				name: VIEW_FIELD_KEYS.REFUND_STATUS,
				label: 'Should Refund'
			},
			{
				name: VIEW_FIELD_KEYS.REFUND_REASON,
				label: 'Reason'
			},
			{
				name: VIEW_FIELD_KEYS.WARNING,
				label: 'Warning'
			},
			{
				name: VIEW_FIELD_KEYS.REFUND_SUGGESTION_RULE_SET_USED,
				label: 'Refund Suggestion Rule Set Used'
			},
			{
				name: VIEW_FIELD_KEYS.IS_LENIENT_REFUND,
				label: 'User Eligible For Leniency Refund'
			},
			{
				name: VIEW_FIELD_KEYS.LENIENCY_REFUND_REASON,
				label: 'Leniency Refund Reason'
			},
			{
				name: VIEW_FIELD_KEYS.IS_INSTANT_RS_YES_REFUND,
				label: 'User Eligible For RS YES Refund'
			},
			{
				name: VIEW_FIELD_KEYS.INSTANT_RS_YES_REFUND_REASON,
				label: 'User RS YES Refund Reason'
			},
			{
				name: VIEW_FIELD_KEYS.REFUND_TYPE,
				label: 'Refund Type'
			}
		],
		fetchData: getRefundSuggestionDetails,
		name: VIEW_FIELD_KEYS.REFUND_SUGGESTION,
		label: 'Refund Suggestion',
		initiallyCollapsed: true
	};
	const keyValueLayout = KEY_VALUE_LAYOUT.VERTICAL;

	return {
		keyConfig,
		keyValueLayout,
		getRefundSuggestionDetails,
		refundSuggestionDetails
	};
};
